import { Link } from "@/components/common/Link";
import { ArrowRight } from "lucide-react";
const relatedLinks = [{
  title: "Phenolic Laser Engraving",
  url: "/services/laser-engraving-phenolic/",
  description: "Two-color phenolic for UL 508A panel nameplates and pushbutton legend plates. The industrial alternative to acrylic for control panel applications."
}, {
  title: "Two-Color Acrylic Material Specifications",
  url: "/materials/two-color-acrylic/",
  description: "Full spec sheet for Evermark's engraving-grade acrylic laminate stock: thicknesses, color combinations, and physical properties."
}, {
  title: "Engraved Nameplates",
  url: "/products/engraved-nameplates/",
  description: "Panel nameplates, equipment nameplates, valve tags, and asset tags in phenolic, acrylic, stainless, and aluminum."
}, {
  title: "Material Comparison Guide",
  url: "/materials/material-comparison-guide/",
  description: "Phenolic vs. acrylic vs. aluminum vs. stainless — which material for which application."
}];
export default function RelatedServices() {
  return <section id="relatedservices" className="bg-background py-10 md:py-16">
      <div className="mx-auto max-w-[1100px] px-6">
        <h2 className="mb-8 font-default text-2xl font-bold text-foreground md:text-3xl">
          Related Products and Services
        </h2>

        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
          {relatedLinks.map((link, i) => <div key={i} data-index={i} className="group flex flex-col gap-3">
              <Link to={link.url} className="inline-flex items-start gap-2 font-default text-base font-semibold text-foreground transition-colors group-hover:text-primary">
                <span className="leading-tight">{link.title}</span>
                <ArrowRight className="mt-0.5 size-4 shrink-0 transition-transform group-hover:translate-x-1" />
              </Link>
              <p className="text-sm leading-relaxed text-muted-foreground">
                {link.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}